/**
 * Copies readable column titles from the first thead row into each tbody cell as data-label,
 * for stacked “card” layouts that render labels via td::before { content: attr(data-label) }.
 *
 * Skips cells that already have data-label, or colspan > 1 (caller should set labels manually).
 */
export function syncResponsiveLabels(tableEl) {
    if (!tableEl?.querySelectorAll) return

    if (
        tableEl.classList.contains('no-responsive-cards') ||
        tableEl.classList.contains('is-responsive-keep')
    )
        return

    const headerRow = tableEl.querySelector('thead tr')
    if (!headerRow) return

    const headerCells = [...headerRow.children].filter(
        el => el.tagName === 'TH' || el.tagName === 'TD'
    )

    if (!headerCells.length) return

    tableEl.querySelectorAll('tbody tr').forEach(row => {
        let col = 0

        for (const cell of [...row.children]) {
            if (cell.tagName !== 'TD' && cell.tagName !== 'TH') continue

            const colspan = parseInt(cell.getAttribute('colspan'), 10) || 1

            if (cell.hasAttribute('data-label')) {
                col += colspan
                continue
            }

            if (colspan > 1) {
                cell.removeAttribute('data-label')
                col += colspan
                continue
            }

            const th = headerCells[col]
            if (th) {
                const label = th.textContent?.trim()
                if (label) cell.setAttribute('data-label', label)
                else cell.removeAttribute('data-label')
            } else cell.removeAttribute('data-label')

            col += 1
        }
    })
}
